import Head from "next/head";
import { useEffect } from "react";
import { useRouter } from "next/router";

const LIGHTWEIGHT_LANDING_ROUTES = new Set([
  "/website-development",
  "/web-development-ab"
]);

const LEGACY_STYLESHEETS = [
  "/css/generated/bootstrap.generated.css",
  "/scss/default/euclid-circulara.generated.css",
  "/css/generated/sal.generated.css",
  "/css/plugins/fontawesome.min.css",
  "/css/plugins/feather.css",
  "/css/plugins/odometer.css",
  "/css/plugins/animation.css",
  "/css/generated/swiper.generated.css",
  "/css/style.css"
];

function usesLightweightLandingAssets(pathname) {
  return LIGHTWEIGHT_LANDING_ROUTES.has(pathname);
}

export default function App({ Component, pageProps }) {
  const router = useRouter();
  const loadLegacyAssets = !usesLightweightLandingAssets(router.pathname);

  useEffect(() => {
    if (!loadLegacyAssets) return undefined;

    let cancelled = false;

    import("bootstrap/dist/js/bootstrap.bundle.min.js").catch((error) => {
      if (!cancelled) {
        console.error("Unable to load the legacy Bootstrap bundle.", error);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [loadLegacyAssets]);

  return (
    <>
      {loadLegacyAssets ? (
        <Head>
          {LEGACY_STYLESHEETS.map((href) => (
            <link
              data-repute-legacy-styles="true"
              href={href}
              key={href}
              rel="stylesheet"
            />
          ))}
        </Head>
      ) : null}

      <Component {...pageProps} />
    </>
  );
}
